module.exports = __webpack_public_path__ + "static/media/description.7ce10fd1.svg";